import NumberRangeBaseController from './number_range_base_controller';

export default class NumberRangeController extends NumberRangeBaseController {}
